<template>
  <aha-modal
    @hide="onCloseModal"
    :title="titleBackstageWindow"
  >
    <p class="mb-2">
      {{ $i18nPresenter.t('This window is just for you. Drag it to the screen only you can see.') }}
    </p>
    <p>
      <aha-checkbox v-model="dontShowAgain">
        {{ $i18nPresenter.t("Don't show this message again") }}
      </aha-checkbox>
    </p>
    <template #action>
      <aha-button
        @click="onCloseModal"
      >
        {{ $i18nPresenter.t('Got it') }}
      </aha-button>
    </template>
  </aha-modal>
</template>

<script>

export default {
  name: 'PresenterWindowNotifyModal',
  data() {
    return {
      dontShowAgain: false,
      titleBackstageWindow: this.$i18nPresenter.t('Backstage Window'),
    }
  },
  methods: {
    onCloseModal() {
      localStorage.setItem('PresenterWindowNotifyModal', JSON.stringify(this.dontShowAgain))
      this.$emit('hide')
    },
  },
}
</script>
